export const HelpScoutArticleKey = {
  PASSKEY_MIGRATION: "passkeyMigration",
  PASSKEY_VS_WALLET: "passkeyVsWallet",
  CONFIDENTIAL_MODE: "confidentialMode",
} as const

export type HelpScoutArticleKey =
  (typeof HelpScoutArticleKey)[keyof typeof HelpScoutArticleKey]

export const helpScoutArticles: Record<
  HelpScoutArticleKey,
  { articleId: string; title: string }
> = {
  [HelpScoutArticleKey.PASSKEY_MIGRATION]: {
    articleId: "69a024a52be6f4d39503a4d8",
    title: "Passkey migration from near-intents.org to near.com",
  },
  [HelpScoutArticleKey.PASSKEY_VS_WALLET]: {
    articleId: "69a04fc140fe578dafbb0898",
    title: "Passkey vs. Web3 wallet — choosing how to sign in",
  },
  [HelpScoutArticleKey.CONFIDENTIAL_MODE]: {
    articleId: "69a0500440fe578dafbb08ad",
    title: "Confidential mode",
  },
}
